import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Icon, IconComponent, Size } from '@circlek-global/lds-components';

import { FUEL_ICON_MAP } from '~constants/fuel-icons';
import { SERVICE_ICON_MAP } from '~constants/service-icons';
import { StationFeatureCategory, StationFuel, StationServiceModel } from '~models/station.model';

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type ServiceWithIcon = {
  name: string;
  displayName: string;
  icon: Icon;
  __brand: 'services';
};
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type FuelWithIcon = {
  name: string;
  displayName: string;
  icon: string;
  __brand: 'fuels';
};

@Component({
  selector: 'app-station-tab-content',
  imports: [IconComponent],
  templateUrl: './station-tab-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StationTabContentComponent {
  readonly items = input.required<(StationServiceModel | StationFuel)[]>();
  readonly icon = input.required<Icon>();
  readonly type = input.required<StationFeatureCategory>();
  protected readonly Size = Size;
  protected readonly itemsWithIcons = computed(() => {
    return this.items().map(({ name, displayName }) => ({
      name: name,
      displayName: displayName,
      icon: this.getItemIcon(name),
      __brand: this.type() === StationFeatureCategory.FUELS ? 'fuels' : 'services',
    })) as (FuelWithIcon | ServiceWithIcon)[];
  });

  protected isFuelItem(item: ServiceWithIcon | FuelWithIcon): item is FuelWithIcon {
    return item['__brand'] === 'fuels';
  }

  private getItemIcon(name: string): Icon | string {
    if (this.type() === StationFeatureCategory.FUELS) return FUEL_ICON_MAP[name];

    return SERVICE_ICON_MAP[name] || this.icon();
  }
}
